import React, { useState } from 'react';

import { Text, Button, useMantineTheme, createStyles } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus, IconChevronDown } from '@tabler/icons-react';
import AthleteNotesTable from 'pages/private/owner/AthleteDetail/components/Notes/components/AthleteNotesTable';
import DrawerNoteForm from 'pages/private/owner/AthleteDetail/components/Notes/components/DrawerNoteForm';
import { AthleteRetrieve } from 'types';

const useStyles = createStyles(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: 'auto auto min-content min-content',
    gridTemplateAreas: `'title title note note'`,
    paddingBottom: theme.spacing.sm,
  },
  title: {
    gridArea: 'title',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing.lg,
  },
  note: {
    gridArea: 'note',
  },
}));
const Notes = ({
  athlete,
  openTabsDrawer,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  openTabsDrawer: () => void;
  permission?: boolean;
}): JSX.Element => {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const [isCreateDrawerOpened, { toggle: handleCreateDrawerToggle }] = useDisclosure(false);
  const [noteId, setNoteId] = useState<string | null>(null);

  const handleViewNote = (id: string): void => {
    setNoteId(id);
    handleCreateDrawerToggle();
  };

  return (
    <>
      <div className={classes.header}>
        <Text size='md' fw='bold' className={classes.title} onClick={openTabsDrawer}>
          Notes
          <IconChevronDown size={16} style={{ marginLeft: 4 }} />
        </Text>
        <Button
          onClick={handleCreateDrawerToggle}
          leftIcon={<IconPlus size={theme.fontSizes.md} />}
          disabled={!permission}
          className={classes.note}
          size='xs'
        >
          Add Note
        </Button>
      </div>
      <AthleteNotesTable
        handleViewNote={handleViewNote}
        athleteId={athlete.athleteId}
        permission={permission}
        margin={0}
        bgc='gray'
      />
      <DrawerNoteForm
        opened={isCreateDrawerOpened}
        closeHandler={handleCreateDrawerToggle}
        athleteId={athlete.athleteId}
        noteId={noteId}
        setNoteId={setNoteId}
        permission={permission}
      />
    </>
  );
};

export default Notes;
